import * as React from "react"
import { Skeleton } from "@mui/material"
import {generateArrayByNumber} from "@ui-seeker/utils";

import { TitleWithPopover, AppTableSeeker } from "@components"
import { isLoadingCommonFilters } from "@signals"
import { useProductPageImageDetailsFilters}  from "../@hooks";
import {dateColumn, retailerColumn, productSkuColumn, imagesColumn, imageMatchColumn, restOfColumn, statusColumn, reportIssueColumn} from "./columns"
import {ShowHideMasterImages} from "./actions";
import IssueModal from "../IssueModal";

const HEIGHT = 500

export default function ProductPageImageDetailsTable() {

    const { data } = useProductPageImageDetailsFilters()

    if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={HEIGHT} />
    if (!data?.length) return <></>

    return <>
        <AppTableSeeker
            title={<TitleWithPopover title="Product Page Image Details" />}
            data={data}
            columns={[
                dateColumn(),
                ...retailerColumn(),
                ...productSkuColumn(),
                ...statusColumn(),
                ...imageMatchColumn(),
                ...generateArrayByNumber(6).map((pos) =>
                    imagesColumn('imagesInGallery', `${pos + 1}`, pos)
                ),
                restOfColumn(),
                reportIssueColumn()
            ]}
            options={{
                customToolbar: () => <ShowHideMasterImages />
            }}
        />
        <IssueModal />
    </>
}